import { alarmNotificationTypeWithCustomConfiguration } from '@/modules/configurationModule/detail/notifications/components/alarms-modal/alarms-modal.models'

export default class AlarmsTypes {
    private readonly alarmTypeCode!: string | null

    constructor(_alarmTypeCode: string | null) {
        this.alarmTypeCode = _alarmTypeCode
    }

    get sampleDiscardDelayReminderAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.SAMPLE_DISCARD_DELAY_REMINDER
    }

    get sampleShelfDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.SAMPLE_SHELF_DELAY
    }

    get sampleGrossingDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.SAMPLE_GROSSING_DELAY
    }

    get requestRegisterDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.REQUEST_REGISTER_DELAY
    }

    get requestUnlockDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.REQUEST_UNLOCK_DELAY
    }

    get caseProximityToGlobalTargetDateAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.CASE_PROXIMITY_TO_GLOBAL_TARGET_DATE
    }

    get caseProximityToDiagnosticTargetDateAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.CASE_PROXIMITY_TO_DIAGNOSTIC_TARGET_DATE
    }

    get requestApReportVisualizationDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.REQUEST_AP_REPORT_VISUALIZATION_DELAY
    }

    get complementaryApReportVisualizationDelayAlarmType() {
        return this.alarmTypeCode === alarmNotificationTypeWithCustomConfiguration.COMPLEMENTARY_AP_REPORT_VISUALIZATION_DELAY
    }
}
